import { compose, defaultTo, length, map } from 'ramda';

import { clear } from '../../../../helpers/compact';
import { PostmenSliceType } from '../../../../types/slice';
import { quote } from '../../partials/quote';

const mapItems = compose(clear, map(quote), defaultTo([]));

export const quotesSlice = ({ items }) => {
  const content = mapItems(items);
  if (length(content)) {
    return {
      type: PostmenSliceType.QUOTES,
      content,
    };
  }
};
